module.exports = __webpack_public_path__ + "static/media/star_icon.7073eca1.svg";